/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Result type for counting the people signed in through a remote_session_client.
 */
export type CountRemoteSessionsResult = {
  /**
   * Distinct user subjects with a live remote_session through the client.
   */
  subjects: number;
};

/** @internal */
export const CountRemoteSessionsResult$inboundSchema: z.ZodMiniType<
  CountRemoteSessionsResult,
  unknown
> = z.object({
  subjects: z.int(),
});

export function countRemoteSessionsResultFromJSON(
  jsonString: string,
): SafeParseResult<CountRemoteSessionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CountRemoteSessionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CountRemoteSessionsResult' from JSON`,
  );
}
